import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaSearch, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import Pagination from '../../common/Pagination';
import SearchBar from '../../common/Search';
import { setState } from '../../redux/features/filtersSlice';
import { useGetNanihalGotraQuery } from "../../redux/services/nanihalGotraService/nanihalGotra.Services";
import { FaPlus } from 'react-icons/fa';
function NanihalGotra() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filter = useSelector((state) => state.filters.state);
    const [statusFilter, setStatusFilter] = useState(filter.status || '');

    const { data, isLoading, isError, refetch } = useGetNanihalGotraQuery(filter);

    const gotraData = data?.data || [];
    const pagination = data?.pagination || {};
    const totalPages = pagination?.totalPages || 0;
    const totalItems = pagination?.total || 0;
    const currentPage = pagination?.page || 1;
    const showPagination = totalPages > 1;

    const isActive = (status) => {
        return status === "active" || status === "Active" || status === 1 || status === true;
    };

    // Handle page change
    const handlePageChange = (page) => {
        dispatch(
            setState({
                page: page,
            })
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Handle search from SearchBar component
    const handleSearch = (value) => {
        dispatch(
            setState({
                search: value,
                page: 1,
            })
        );
    };

    // Refetch function for callbacks
    const refetchData = () => {
        refetch();
    };

    // Handle status filter
    const handleStatusFilter = (status) => {
        setStatusFilter(status);
        dispatch(
            setState({
                status: status,
                page: 1,
            })
        );
    };

    // Clear all filters
    const clearFilters = () => {
        setStatusFilter('');
        dispatch(
            setState({
                search: '',
                status: '',
                page: 1,
            })
        );
    };

    // Handle limit change
    const handleLimitChange = (e) => {
        const newLimit = parseInt(e.target.value);
        dispatch(
            setState({
                limit: newLimit,
                page: 1,
            })
        );
    };

    // Handle refresh
    const handleRefresh = () => {
        refetch();
        successToast("Data refreshed successfully!");
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h5 className="mt-3">Loading Nanihal Gotra data...</h5>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="text-center py-5">
                <div className="alert alert-danger">
                    <h5>Something Went Wrong</h5>
                    <p>Unable to load Nanihal Gotra data. Please try again.</p>
                    <button className="btn btn-primary" onClick={handleRefresh}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* HEADER */}
           <div className="dashboard-header">
    <div className="dashboard-header-inner">

        <div className="header-content">
         

            <h2 className="page-title">
                All Nanihal Gotra

                {totalItems > 0 && (
                    <span className="count-badge">
                        {totalItems}
                    </span>
                )}
            </h2>

            <div className="custom-breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <span className="active">All Nanihal Gotra</span>
            </div>
        </div>

        <button
            onClick={() => navigate("/add-nanihal-gotra")}
            className="btn btn-primary add-btn"
        >
            <FaPlus className="me-2" />
            Add Nanihal Gotra
        </button>

    </div>
</div>

            {/* SEARCH AND FILTER SECTION */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className="row g-3 align-items-center">
                        {/* Search Bar */}
                        <div className="col-md-4">
                            <SearchBar
                                search={filter.search}
                                setSearch={handleSearch}
                                placeholder="Search Nanihal Gotra by name..."
                            />
                        </div>

                        {/* Status Filter */}
                        <div className="col-md-3">
                            <select
                                className="form-select"
                                value={statusFilter}
                                onChange={(e) => handleStatusFilter(e.target.value)}
                            >
                                <option value="">All Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </div>

                        {/* Limit Filter */}
                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={filter.limit}
                                onChange={handleLimitChange}
                            >
                                <option value={5}>5 per page</option>
                                <option value={10}>10 per page</option>
                                <option value={20}>20 per page</option>
                                <option value={50}>50 per page</option>
                                <option value={100}>100 per page</option>
                            </select>
                        </div>

                        {/* Action Buttons */}
                        <div className="col-md-3 text-md-end">
                            {(filter.search || filter.status) && (
                                <button
                                    className="btn btn-outline-secondary me-2"
                                    onClick={clearFilters}
                                >
                                    <FaTimes className="me-1" />
                                    Clear Filters
                                </button>
                            )}
                            <button
                                className="btn btn-outline-primary"
                                onClick={handleRefresh}
                            >
                                Refresh
                            </button>
                        </div>
                    </div>

                    {/* Active Filters Display */}
                    {(filter.search || filter.status) && (
                        <div className="mt-3 d-flex flex-wrap gap-2">
                            <span className="text-muted me-2">Active Filters:</span>
                            {filter.search && (
                                <span className="badge bg-primary d-flex align-items-center gap-1">
                                    Search: {filter.search}
                                    <button
                                        className="btn btn-link btn-sm text-white p-0 ms-1"
                                        onClick={() => handleSearch('')}
                                    >
                                        <FaTimes />
                                    </button>
                                </span>
                            )}
                            {filter.status && (
                                <span className="badge bg-info d-flex align-items-center gap-1">
                                    Status: {filter.status}
                                    <button
                                        className="btn btn-link btn-sm text-white p-0 ms-1"
                                        onClick={() => handleStatusFilter('')}
                                    >
                                        <FaTimes />
                                    </button>
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* TABLE */}
            <div className="st-wrapper-card">
                {gotraData.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="mb-3">
                            <FaSearch className="text-muted" size={48} />
                        </div>
                        <h5>No Nanihal Gotra Found</h5>
                        <p className="text-muted">
                            {filter.search || filter.status
                                ? "Try adjusting your search or filter criteria"
                                : "Click 'Add Nanihal Gotra' to create your first nanihal gotra"}
                        </p>
                        {(filter.search || filter.status) && (
                            <button className="btn btn-primary" onClick={clearFilters}>
                                Clear Filters
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nanihal Gotra Name</th>
                                    <th>Status</th>
                                    <th>Change Status</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {gotraData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>
                                            {(currentPage - 1) * filter.limit + index + 1}
                                        </td>
                                        <td className="fw-semibold">
                                            {item?.nanihal_gotra_name || item?.name || 'N/A'}
                                        </td>
                                        <td>
                                            <span className={`badge ${isActive(item.status) ? 'bg-success' : 'bg-danger'}`}>
                                                {isActive(item.status) ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td style={{ width: "150px" }}>
                                            <div className="city-status-switch">
                                                <input
                                                    type="checkbox"
                                                    id={`status-${item.id}`}
                                                    className="city-status-input"
                                                    checked={isActive(item.status)}
                                                    onChange={() =>
                                                        dispatch(
                                                            openModal({
                                                                type: "status-nanihal-gotra",
                                                                title: "Change Nanihal Gotra Status",
                                                                data: {
                                                                    id: item.id,
                                                                    name: item.nanihal_gotra_name || item.name,
                                                                    status: item.status,
                                                                    apiUrl: "/nanihal-gotra-status",
                                                                    message: `Are you sure you want to change status of "${item.nanihal_gotra_name || item.name}"?`,
                                                                    onSuccess: refetchData,
                                                                },
                                                            })
                                                        )
                                                    }
                                                />
                                                <label htmlFor={`status-${item.id}`} className="city-status-label">
                                                    <span className="city-status-ball"></span>
                                                    <span className="city-status-text">
                                                        {isActive(item.status) ? "Active" : "Inactive"}
                                                    </span>
                                                </label>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            {/* VIEW */}
                                            <button
                                                className="st-action-btn st-view-btn me-1"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-nanihal-gotra",
                                                            title: "View Nanihal Gotra",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                                title="View Details"
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT */}
                                            <button
                                                className="st-action-btn st-edit-btn me-1"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-nanihal-gotra",
                                                            title: "Edit Nanihal Gotra",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                                title="Edit Nanihal Gotra"
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "delete-nanihal-gotra",
                                                            title: "Delete Nanihal Gotra",
                                                            data: {
                                                                id: item.id,
                                                                name: item.nanihal_gotra_name || item.name,
                                                                apiUrl: "/nanihal-gotra-delete",
                                                                message: `Are you sure you want to delete "${item.nanihal_gotra_name || item.name}"?`,
                                                                onSuccess: refetchData,
                                                            },
                                                        })
                                                    )
                                                }
                                                title="Delete Nanihal Gotra"
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* PAGINATION */}
                {showPagination && gotraData.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center justify-content-between mt-4">
                        <div className="text-muted small mb-2 mb-md-0">
                            Showing {((currentPage - 1) * filter.limit) + 1} to{' '}
                            {Math.min(currentPage * filter.limit, totalItems)} of {totalItems} entries
                        </div>
                        <Pagination
                            page={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default NanihalGotra;